import styled from "styled-components";
import Tabela2 from "../../Componentes/Utils/Tabela2";
import { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { formatarData } from "../../Funcoes/FormatarData";
import MultiselectCheck from "../../Componentes/Utils/MultiselectCheck";
import ExtractUniqueValues from "../../Funcoes/ExtractUniqueValues";
import InputUtil from "../../Componentes/Utils/InputUtil";
import { useModal } from "../../contexts/ModalContext";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const Coluna = styled.td`
    white-space: nowrap;
`
const HeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`
const Header = styled.div`
    flex: 1;
    background-color: #f0f0f0;
    flex-shrink: 0;
    gap: 10px;
    padding: 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-radius: 8px;
`
const StatistcsWrapper = styled.div`
    width: 300px;
    height: 100%;
    flex-shrink: 0;
    background-color: #f0f0f0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    & h3 {
        margin: 0 0 10px 0;
    }
    & p {
        margin: 2px 0;
    }
`
const StatistcsColumns = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-evenly;
`
const StatistcsColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const TableWrapper = styled.div`
    flex: 1;
    width: 100%;
    overflow: hidden;
`

const Content = () => {

    const api = useApi();

    const { isModalOpen, closeModal } = useModal();

    const [loading, setLoading] = useState(false);

    const [dados, setDados] = useState([]);
    const [filteredDados, setFilteredDados] = useState([]);

    const fetchDados = async () => {

        setLoading(true);

        try {

            const { data } = await api.get('/Painel/API/EquipCalib/');
            console.log(data);

            setDados(data);
            setFilteredDados(data);

        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        fetchDados();

    }, [])

    const [localizadorOptions, setLocalizadorOptions] = useState([]);

    useEffect(() => {

        if (dados.length === 0) return;

        setLocalizadorOptions(ExtractUniqueValues(dados, 'LOCAL'));

    }, [dados])

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedDescricao, setSelectedDescricao] = useState('');
    const [selectedNumSerie, setSelectedNumSerie] = useState('');
    const [selectedCertificado, setSelectedCertificado] = useState('');
    const [selectedLocalizadores, setSelectedLocalizadores] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedDataInicio, setSelectedDataInicio] = useState('');
    const [selectedDataFim, setSelectedDataFim] = useState('');

    useEffect(() => {

        let filtered = dados;

        //O primeiro filtro verifica se o item está 100% completo, ou seja, se tem número de série, data de calibração, certificado, validade e localizador. Se tiver tudo isso, ele é considerado "OK", caso contrário, é considerado "ITENS PENDENTES"
        if (selectedOptions.length > 0) {
            if (selectedOptions.includes('OK') && !selectedOptions.includes('ITENS PENDENTES')) {
                filtered = filtered.filter(item => item.NUM_SERIE && item.DT_CALIBRACAO && item.CERTIFICADO && item.VALIDADE && item.LOCAL);
            }
            else if (selectedOptions.includes('ITENS PENDENTES') && !selectedOptions.includes('OK')) {
                filtered = filtered.filter(item => !item.NUM_SERIE || !item.DT_CALIBRACAO || !item.CERTIFICADO || !item.VALIDADE || !item.LOCAL);
            }
        }
        if (selectedDescricao) { filtered = filtered.filter(item => item.DESCRICAO.toLowerCase().includes(selectedDescricao.toLowerCase())) }
        if (selectedNumSerie) { filtered = filtered.filter(item => item.NUM_SERIE && item.NUM_SERIE.toLowerCase().includes(selectedNumSerie.toLowerCase())) }
        if (selectedCertificado) { filtered = filtered.filter(item => item.CERTIFICADO && item.CERTIFICADO.toLowerCase().includes(selectedCertificado.toLowerCase())) }
        if (selectedLocalizadores.length > 0) { filtered = filtered.filter(item => item.LOCAL && selectedLocalizadores.includes(item.LOCAL)) }
        if (selectedStatus.length > 0) { filtered = filtered.filter(item => selectedStatus.includes(item.STATUS)) }
        if (selectedDataInicio) {
            filtered = filtered.filter(item => {
                if (!item.DT_CALIBRACAO) return false;
                const itemDate = new Date(item.DT_CALIBRACAO);
                const selectedStartDate = new Date(selectedDataInicio);
                return itemDate >= selectedStartDate;
            });
        }
        if (selectedDataFim) {
            filtered = filtered.filter(item => {
                if (!item.DT_CALIBRACAO) return false;
                const itemDate = new Date(item.DT_CALIBRACAO);
                const selectedEndDate = new Date(selectedDataFim);
                return itemDate <= selectedEndDate;
            });
        }

        setFilteredDados(filtered);

    }, [selectedOptions, selectedDescricao, selectedNumSerie, selectedCertificado, selectedLocalizadores, selectedStatus, selectedDataInicio, selectedDataFim, dados]);

    const [ generatingPDF, setGeneratingPDF ] = useState( false );

    const generatePDF = async () => {

        setGeneratingPDF( true );

        try{

            const idList = filteredDados.map(item => item.ID);

            const { data } = await api.post('/Painel/API/EquipCalib/GeneratePDF/', {
                ids: idList
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            console.log( data );

            //Pegar arquivo PDF retornado em base64 e fazer o download
            //Usar a biblioteca file-saver para isso

            const byteCharacters = atob(data.pdf);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'relatorio_calibracao.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        }catch( e ){

            console.log( e );

        }finally{

            setGeneratingPDF( false );

        }

    }

    return (
        <>
            <Container>
                <HeaderWrapper>
                    <Header>
                        <MultiselectCheck
                            options={[
                                { label: 'ITENS PENDENTES', value: 'ITENS PENDENTES' },
                                { label: 'OK', value: 'OK' }
                            ]}
                            placeholder="SITUAÇÃO..."
                            selectedOptions={selectedOptions}
                            setSelectedOptions={setSelectedOptions}
                        />
                        <InputUtil
                            placeholder="DESCRIÇÃO..."
                            value={selectedDescricao}
                            onChange={e => setSelectedDescricao(e.target.value)}
                        />
                        <InputUtil
                            placeholder="NUM. SÉRIE..."
                            value={selectedNumSerie}
                            onChange={e => setSelectedNumSerie(e.target.value)}
                        />
                        <InputUtil
                            placeholder="CERTIFICADO..."
                            value={selectedCertificado}
                            onChange={e => setSelectedCertificado(e.target.value)}
                        />
                        <MultiselectCheck
                            options={localizadorOptions}
                            placeholder="LOCALIZADOR..."
                            selectedOptions={selectedLocalizadores}
                            setSelectedOptions={setSelectedLocalizadores}
                        />
                        <MultiselectCheck
                            options={[
                                { label: 'VÁLIDO', value: 'VALIDO' },
                                { label: 'A VENCER', value: 'A VENCER' },
                                { label: 'VENCIDO', value: 'VENCIDO' },
                                { label: 'PENDENTE', value: 'PENDENTE' }
                            ]}
                            placeholder="STATUS"
                            selectedOptions={selectedStatus}
                            setSelectedOptions={setSelectedStatus}
                        />
                        <InputUtil
                            type="date"
                            value={selectedDataInicio}
                            onChange={e => setSelectedDataInicio(e.target.value)}
                        />
                        <InputUtil
                            type="date"
                            value={selectedDataFim}
                            onChange={e => setSelectedDataFim(e.target.value)}
                        />
                    </Header>
                    <StatistcsWrapper>
                        <h3>Total: {filteredDados.length}</h3>
                        <StatistcsColumns>
                            <StatistcsColumn>
                                <p>Válidos: {filteredDados.filter(item => item.STATUS === 'VALIDO').length}</p>
                                <p>A Vencer: {filteredDados.filter(item => item.STATUS === 'A VENCER').length}</p>
                            </StatistcsColumn>
                            <StatistcsColumn>
                                <p>Vencidos: {filteredDados.filter(item => item.STATUS === 'VENCIDO').length}</p>
                                <p>Pendentes: {filteredDados.filter(item => item.STATUS === 'PENDENTE').length}</p>
                            </StatistcsColumn>
                        </StatistcsColumns>
                    </StatistcsWrapper>
                </HeaderWrapper>
                <TableWrapper>
                    <Tabela2>
                        <thead>
                            <tr>
                                <th>CODIGO</th>
                                <th>DESCRIÇÃO</th>
                                <th>NUM. SERIE</th>
                                <th>DATA CALIBRAÇÃO</th>
                                <th>CERTIFICADO</th>
                                <th>VALIDADE</th>
                                <th>LOCALIZADOR</th>
                                <th>STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredDados.map((item, index) => (
                                    <tr key={index}>
                                        <Coluna>{item.CODIGO}</Coluna>
                                        <Coluna>{item.DESCRICAO}</Coluna>
                                        <Coluna>{item.NUM_SERIE ? item.NUM_SERIE : '-'}</Coluna>
                                        <Coluna>{item.DT_CALIBRACAO ? formatarData(item.DT_CALIBRACAO) : '-'}</Coluna>
                                        <Coluna>{item.CERTIFICADO ? item.CERTIFICADO : '-'}</Coluna>
                                        <Coluna>{item.VALIDADE ? formatarData(item.VALIDADE) : '-'}</Coluna>
                                        <Coluna>{item.LOCAL ? item.LOCAL : '-'}</Coluna>
                                        <Coluna>{item.STATUS}</Coluna>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Tabela2>
                </TableWrapper>
            </Container>
            {
                isModalOpen('sidebarEquipCalibracao') && (
                    <Overlay state={ true } changeContent={ closeModal } >
                        <SideMenu>
                            <SideMenuBtn
                                button="GERAR RELATÓRIO PDF"
                                isLoading={ generatingPDF }
                                clickFunc={ generatePDF }
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
        </>
    )
}

export default Content;